module.exports = __webpack_public_path__ + "static/media/ppt.acb542f2.png";